import { ThemeProvider } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Hidden from '@mui/material/Hidden';
import Toolbar from '@mui/material/Toolbar';
import clsx from 'clsx';
import NavbarToggleButton from './NavbarToggleButton';
import { toolbarTheme } from '../styles/defaultTheme';
import UserMenu from './UserMenu';
import NotificationsMenu from '../components/NotificationsMenu';

interface Props {
  className: string;
}

const ToolbarLayout = (props: Props) => {
  return (
    <ThemeProvider theme={toolbarTheme}>
      <AppBar
        id="fuse-toolbar"
        className={clsx('flex relative z-20 shadow-md', props.className)}
        color="default"
        sx={{
          backgroundColor: toolbarTheme.palette.background.paper,
        }}
        position="static"
      >
        <Toolbar className="p-0 min-h-48 md:min-h-64">
          <div className="flex flex-1 px-16">
            <Hidden lgUp>
              <NavbarToggleButton className="w-40 h-40 p-0 mx-0 sm:mx-8" />
            </Hidden>
          </div>
          
          <div className="flex items-center px-8 h-full overflow-x-auto">
            <NotificationsMenu />
            <UserMenu />
          </div>
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  );
};

export default ToolbarLayout;
